import {Injectable} from '@angular/core';
import {TextBase} from '../classes/text-base';

/**
 * visibility 텍스트
 * @link http://imrbiz.co.kr/documents/types/field-visibility.html
 * @description
 * __상태 유형__
 * - visibility : 상태
 * - fieldAble : 허용 상태
 * - fieldActive : 활성 상태
 *
 * __상태 값__
 * - default : 0 (기본)
 * - enable : 0 (허용)
 * - active : 0 (활성)
 * - beforeApproval : 203 (승인 전)
 * - disable : 204 (비허용)
 * - inactive : 306 (비활성)
 * - awaitApproval : 401 (승인 대기)
 * - disapproval : 403 (승인 거절)
 * - delete : 404 (삭제)
 * - deleted : 410 (완전 삭제)
 * - lock : 423 (잠금)
 * @deprecated LazyPhraseService 사용
 */
@Injectable({
	providedIn: 'root'
})
export class VisibilityText extends TextBase {
	override readonly en = {
		visibility: 'Visibility',
		fieldAble: 'Field Able',
		fieldActive: 'Field Active',
		enable: 'Enable',
		active: 'Active',

		none: 'None',
		default: 'Default',
		beforeApproval: 'Before Approval',
		disable: 'Disable',
		inactive: 'Inactive',
		awaitApproval: 'Await Approval',
		disapproval: 'Disapproval',
		delete: 'Delete',
		deleted: 'Deleted',
		lock: 'Lock'
	};

	override readonly kr = {
		visibility: '상태',
		fieldAble: '허용 상태',
		fieldActive: '활성 상태',
		enable: '허용',
		active: '활성',

		none: '기본',
		default: '기본',
		beforeApproval: '승인 전',
		disable: '비허용',
		inactive: '비활성',
		awaitApproval: '승인 대기',
		disapproval: '승인 거절',
		delete: '삭제',
		deleted: '완전 삭제',
		lock: '잠금'
	};
}
